import { useContext } from "react";
import { ConfirmContext, confirmPlainText, type ConfirmOptions } from "@/contexts/confirm-context";

/**
 * useConfirm — native window.confirm 대체. Promise<boolean> 반환.
 *   const confirm = useConfirm();
 *   const ok = await confirm({ title: "배합을 삭제할까요?", summary: "'C-25' 배합", irreversible: true, kind: "danger", confirmLabel: "삭제" });
 *   if (!ok) return;
 *
 * Provider가 없으면 native window.confirm으로 폴백 (안전).
 */
export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  return (opts: ConfirmOptions): Promise<boolean> => {
    if (ctx) return ctx.confirm(opts);
    const text = confirmPlainText(opts);
    return Promise.resolve(window.confirm(text));
  };
}
